<template>
<div v-show="items.length">
    <v-card class="d-flex justify-space-between" elevation="0" tile light>
        <v-card @click.prevent.stop="$router.push('/action/'+items[id(i,it)].id)" v-for="it in sliderCols" :key="it" elevation="0" tile  :height="$vuetify.breakpoint.smAndUp ? `205` : `193`" :width="100/sliderCols+'%'" class="d-flex justify-space-around pa-1 ">
            <v-hover v-slot:default="{ hover }" open-delay="100" v-if="items[id(i,it)]">
                <!-- Использовать темплейт -->
                <v-card color="grey lighten-3" width="100%" tile :elevation="hover ? 6 : 2" v-if="!items[id(i,it)].b2b_not_use_template">
                    <v-img height="100%" :src="conf[iterator(it)].img">
                        <v-container fill-height class="d-flex justify-space-between pa-4">
                            <div class="container pa-0 pr-2 ma-0 d-flex justify-space-between flex-column action-text">
                                <v-container :class="conf[iterator(it)].color + `--text pa-0`">
                                    <!-- <v-img height="45" width="100" contain :src="items[id(i,it)].logo ? 'https://intranet.yugcontract.ua/'+items[id(i,it)].logo : `/img/nophoto_logo.png`"></v-img> -->

                                <v-img height="45" width="100" v-if="!items[id(i,it)].logoImg && items[id(i,it)].logo" contain :src="'https://intranet.yugcontract.ua/'+items[id(i,it)].logo"></v-img>
                                <v-img height="45" width="100" v-if="items[id(i,it)].logoImg" contain :src="'https://b2b.yugcontract.ua/fileslibrary/ws/images/logo/'+items[id(i,it)].logoImg"></v-img>
                                <v-img height="45" width="100" v-if="!items[id(i,it)].logoImg && !items[id(i,it)].logo" contain src="/img/nophoto_logo.png"></v-img>

                                    <div class="text-uppercase body-2 my-2" v-html="items[id(i,it)].b2b_name ? items[id(i,it)].b2b_name : items[id(i,it)].name"></div>
                                </v-container>
                            <v-card-actions class="pa-0">
                                <div :class="`caption ` + conf[iterator(it)].color + `--text`">
                                    {{items[id(i,it)].date_from}} - {{items[id(i,it)].date_to}}
                                </div>
                            </v-card-actions>
                            </div>
                                <v-avatar tile size="150">
                                    <v-img :lazy-src="nophoto" :src="items[id(i,it)].photo ? 'https://intranet.yugcontract.ua/'+items[id(i,it)].photo : `/img/nophoto.png`"></v-img>
                                </v-avatar>
                        </v-container>
                    </v-img>
                </v-card>
                <!-- Не использовать темплейт -->
                <v-card color="white lighten-3" width="100%" tile :elevation="hover ? 6 : 2" v-else>
                    <v-img height="100%" :lazy-src="nophoto" :src="items[id(i,it)].photo ? 'https://intranet.yugcontract.ua/'+items[id(i,it)].photo : conf[iterator(it)].img" >
                    </v-img>
                </v-card>

            </v-hover>
        </v-card>
    </v-card>
</div>
</template>

<script>
export default {
    props: {
        items: Array,
        title: String,
        i: Number,
        sliderCols: Number,
        totalSlides: Number,
        loading: Boolean
    },
    data() {
        return {
            nophoto: 'data:image/png;base64,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',
            f: 0,
            hover: false,
            index: 0,
            conf: [{
                    img: '/img/gradient-01.png',
                    color: 'black',
                },
                {
                    img: '/img/gradient-02.png',
                    color: 'black',
                },
                {
                    img: '/img/gradient-03.png',
                    color: 'black',
                },
            ]
        }
    },
    methods: {
        id(i, it) {
            const id = (i - 1) * this.sliderCols + it - 1
            return id
        },
        goURL(url) {
            window.open(url, "_blank")
        },
        iterator(id) {
            return this.sliderCols > 1 ? id % this.conf.length : this.i % 2
        }
    },
    created() {
    },
    computed: {},
}
</script>

<style>
.action-text {height: 100%; max-width: 60%;}
.action-text div {max-height: 130px; overflow: hidden;}
.action-text + .v-avatar {width: 40% !important; min-width: 40% !important; max-height: 150px !important; }

@media (max-width: 468px) {
    .action-text {max-width: 58%;}
    .action-text + .v-avatar {width: 42% !important; min-width: 42% !important; height: 130px !important; }
}

</style>